import { LINKS_SSO_OFF, LINKS_SSO_ON } from '../actions/site';

const initialState = {
  sso: false,
};

export default (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case LINKS_SSO_ON:
      return {
        ...state,
        sso: true,
      };
    case LINKS_SSO_OFF:
      return {
        ...state,
        sso: false,
      };
    /* istanbul ignore next -- @preserve */
    default:
      return state;
  }
};
